export default __webpack_public_path__ + "static/media/careers.56e3ff96.jpg";